export type DashboardReadResource = 'orders' | 'bookings' | 'forms'
type ReadEvent = { token: string; projectId?: string; resource: DashboardReadResource; id: string }
const EVENT = 'veltica:dashboard-item-read'

/** Emit only after the server accepts the read receipt. */
export function notifyDashboardItemRead(event: ReadEvent) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENT, { detail: event }))
}

export function onDashboardItemRead(listener: (event: ReadEvent) => void) {
  const handle = (event: Event) => listener((event as CustomEvent<ReadEvent>).detail)
  window.addEventListener(EVENT, handle)
  return () => window.removeEventListener(EVENT, handle)
}
